/**
 * Die für Nutzer gedachte Meldung aus einer Fehlerantwort des Backends.
 *
 * <p>Zwei Formen kommen vor: der {@code WorkflowExceptionHandler} liefert JSON mit
 * {@code details} (Liste) und {@code message}, ein {@code AccessDeniedException} kommt als reiner
 * Text „Access Denied: …" zurück. Das Präfix ist Technik und wird entfernt.
 */
export function serverErrorMessage(err: unknown, fallback: string): string {
  const body = (err as { error?: unknown } | null)?.error;
  if (typeof body === 'string') {
    const text = body.replace(/^Access Denied:\s*/, '').trim();
    return text || fallback;
  }
  const json = body as { details?: string[]; message?: string } | undefined;
  return json?.details?.[0] || json?.message || fallback;
}
